import { useState, useEffect } from 'react';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, setLogLevel } from 'firebase/firestore';
import { MANUAL_FIREBASE_CONFIG } from '../config'; 
import { AppSettings } from '../types';
import { VENMO_USERNAME } from '../config';

const DEFAULT_SETTINGS: AppSettings = {
    venmoUsername: VENMO_USERNAME
};

export const useAppConfig = (user: any) => {
    const [isConfigured, setIsConfigured] = useState(true);
    const [app, setApp] = useState<any>(null);
    const [auth, setAuth] = useState<any>(null);
    const [db, setDb] = useState<any>(null);
    const [appId, setAppId] = useState<string>('yoga-app-local');
    const [appSettings] = useState<AppSettings>(DEFAULT_SETTINGS);

    useEffect(() => {
        // Use window global if available (Canvas environment), otherwise manual config
        const envFirebaseConfig = typeof window !== 'undefined' && (window as any).__firebase_config ? (window as any).__firebase_config : null;
        const rawAppId = typeof window !== 'undefined' && (window as any).__app_id ? (window as any).__app_id : 'yoga-app-local';
        const SAFE_APP_ID = rawAppId.split('/')[0];
        
        let firebaseConfig: any;
        let configured = true;

        if (envFirebaseConfig) {
            firebaseConfig = JSON.parse(envFirebaseConfig);
        } else {
            firebaseConfig = MANUAL_FIREBASE_CONFIG;
            if (firebaseConfig.apiKey.includes("PASTE_YOUR")) {
                configured = false;
            }
        }

        if (configured) {
            try {
                const firebaseApp = initializeApp(firebaseConfig);
                setApp(firebaseApp);
                setAuth(getAuth(firebaseApp));
                setDb(getFirestore(firebaseApp));
                setLogLevel('silent');
            } catch (e) {
                console.error("Firebase Initialization Error:", e);
                configured = false;
            }
        }

        setIsConfigured(configured);
        setAppId(SAFE_APP_ID);
    }, []);

    // Fetch App Settings (PIN/Venmo) from Firestore
    // Environment config handling is sufficient, removing legacy Firestore settings fetch.
    
    // Original fetch logic removed. Use env variables via config.ts.

    return { isConfigured, app, auth, db, appId, appSettings };
};
